import { render } from "./title.vue?vue&type=template&id=6b23aa9e&scoped=true"
import script from "./title.vue?vue&type=script&lang=ts"
export * from "./title.vue?vue&type=script&lang=ts"

import "./title.vue?vue&type=style&index=0&id=6b23aa9e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6b23aa9e"

export default script